/**
 * lazyPage.js – Seiten erst bei Bedarf nachladen (Code-Splitting).
 *
 * Wie React.lazy, fängt aber den typischen Fehler nach einem Deploy ab: ein
 * noch offener Tab kennt nur die Chunk-Namen des alten Builds, die es auf dem
 * Server nicht mehr gibt. Statt einer Fehlerseite wird die Seite dann einmal
 * neu geladen und holt sich den aktuellen Build. Scheitert es auch danach
 * (z. B. offline), wird der Fehler normal weitergereicht.
 */
import { lazy } from 'react';

const RELOAD_KEY = 'chunkReloadAt';
const RELOAD_SPERRE_MS = 30_000;

function istChunkFehler(error) {
  return error?.name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message ?? '');
}

export default function lazyPage(importer) {
  return lazy(() => importer().catch((error) => {
    if (!istChunkFehler(error)) throw error;

    let zuletzt = 0;
    try {
      zuletzt = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
    } catch {
      // sessionStorage nicht verfügbar – setItem unten scheitert dann auch,
      // es wird nicht neu geladen (keine Endlosschleife).
    }
    if (Date.now() - zuletzt < RELOAD_SPERRE_MS) throw error;

    try {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      throw error;
    }
    window.location.reload();
    // Bis zum Neuladen nichts rendern.
    return new Promise(() => {});
  }));
}

/** Platzhalter, solange eine Seite nachgeladen wird. */
export function SeiteLaedt() {
  return (
    <div className="flex items-center gap-2 text-slate-400 py-10 justify-center">
      <span className="spinner" /> Laden…
    </div>
  );
}
